import Route from '@ember/routing/route';
import { service } from '@ember/service';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import { DAY_BY_DAY_PATHS } from 'lumen/utils/spider';

@protectedRoute({ features: ['spider.day_by_day'] })
export default class HotelDayByDayIndexRoute extends Route {
  @service router;

  redirect() {
    this.router.replaceWith(
      'hotel.day-by-day.spider-dashboard',
      DAY_BY_DAY_PATHS[0],
    );
  }
}
